module.exports = __webpack_public_path__ + "img/trophy.4b9435b3.png";